module.exports = __webpack_public_path__ + "static/media/id.186e83ea.webp";